import { createContext, useContext, useState, useCallback } from 'react';

const BookVisitContext = createContext(null);

export const BookVisitProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [propertyInfo, setPropertyInfo] = useState(null);

  const openModal = useCallback((property = null) => {
    setPropertyInfo(property);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setPropertyInfo(null);
  }, []);

  return (
    <BookVisitContext.Provider value={{ isOpen, propertyInfo, openModal, closeModal }}>
      {children}
    </BookVisitContext.Provider>
  );
};

export const useBookVisit = () => {
  const context = useContext(BookVisitContext);
  if (!context) {
    throw new Error('useBookVisit must be used within a BookVisitProvider');
  }
  return context;
};
